module.exports = __webpack_public_path__ + "img/bean.dee4d7d7.png";